import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@heroui/react';
import { DatePickerField } from '@/components';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import type { ManualImportForm } from '../useManualImport';
import { LabeledSelect } from './LabeledSelect';
import { LabeledTextField } from './LabeledTextField';

type MetaSectionProps = {
    form: ManualImportForm;
};

/** Supplier / branch / invoice number / date — the import's header fields. */
export const MetaSection: React.FC<MetaSectionProps> = ({ form }) => {
    const { t } = useTranslation('pages');
    const { state } = form;

    return (
        <section {...getNodeTestIdProp('manual-import-meta')}>
            <Card {...getNodeTestIdProp('manual-import-meta-card')}>
                <Card.Content
                    className="grid grid-cols-1 items-start gap-4 sm:grid-cols-2 lg:grid-cols-4"
                    {...getNodeTestIdProp('manual-import-meta-content')}
                >
                    <LabeledSelect
                        label={t('purchases.manualImport.supplier')}
                        onChange={(value) =>
                            form.onSupplierChange(value || null)
                        }
                        options={form.supplierOptions}
                        placeholder={t(
                            'purchases.manualImport.supplierPlaceholder',
                        )}
                        slot="supplier"
                        value={state.supplierId ?? ''}
                    />
                    <LabeledSelect
                        label={t('purchases.manualImport.branch')}
                        onChange={(value) => form.onBranchChange(value || null)}
                        options={form.branchOptions}
                        placeholder={t(
                            'purchases.manualImport.branchPlaceholder',
                        )}
                        slot="branch"
                        value={state.branchId ?? ''}
                    />
                    <LabeledTextField
                        label={t('purchases.manualImport.invoiceNumber')}
                        onChange={form.onInvoiceNumberChange}
                        slot="invoice-number"
                        value={state.invoiceNumber}
                    />
                    <DatePickerField
                        id="manual-import-date"
                        label={t('purchases.manualImport.date')}
                        name="manual-import-date"
                        onChange={form.onDateChange}
                        value={state.date}
                    />
                </Card.Content>
            </Card>
        </section>
    );
};
